import { correctionStore } from '@bracesDesigner/correction/store/correctionState.ts';

const useCorrectionStore = () => {
  const tick = correctionStore((state) => state.tick);
  const jaws = correctionStore((state) => state.jaws);
  const setJaws = correctionStore((state) => state.setJaws);
  const updateStore = correctionStore((state) => state.updateStore);
  const resetToothPos = correctionStore((state) => state.resetToothPos);
  const resetToothRot = correctionStore((state) => state.resetToothRot);
  const reset = correctionStore((state) => state.reset);

  return {
    tick,
    jaws,
    setJaws,
    updateStore,
    resetToothPos,
    resetToothRot,
    reset,
  };
};

export default useCorrectionStore;
